import { EOtpActionTypes } from '../../actions/otp';
import { EStatus } from '../../types/auth';
import { TReduxActions } from '../../types/redux';

const defaultState: { otp: string; fetchOtpStatus: EStatus; fetchOtpError: string } = {
  otp: '',
  fetchOtpStatus: EStatus.IDLE,
  fetchOtpError: '',
};

export function otpReducer(
  state: { otp: string; fetchOtpStatus: EStatus; fetchOtpError: string } = defaultState,
  action: TReduxActions,
) {
  switch (action.type) {
    case EOtpActionTypes.ChangeOtp:
      return {
        ...state,
        otp: action.payload,
        fetchOtpError: '',
      };

    case EOtpActionTypes.ConfirmOtpRequest:
      return {
        ...state,
        fetchOtpStatus: EStatus.LOADING,
      };

    case EOtpActionTypes.ConfirmOtpSuccess:
      return {
        ...state,
        fetchOtpStatus: EStatus.SUCCESS,
      };

    case EOtpActionTypes.ConfirmOtpError:
      return {
        ...state,
        fetchOtpStatus: EStatus.ERROR,
        fetchOtpError: action.payload,
      };
    default:
      return state;
  }
}
